import PropTypes from "prop-types"
import styled from "styled-components"

const ContentContainer = styled.div`
  position: relative;
  width: 80%;
  max-width: 1000px;
  margin: 0px auto;
  .ql-toolbar {
    z-index: 999999999;
  }

  ${(p) =>
    p.flexForPrint
      ? `
    @media print {
      & {
        display: flex;
        flex-direction: column;
      }
    }
  `
      : ""}

  ${(p) =>
    p.isFlexRow
      ? `
    @media print {
      & {
      flex-direction: row;
      }
    }
  `
      : ""}
`

ContentContainer.displayName = "ContentContainer"

ContentContainer.propTypes = {
  // This solves an issue with blocks that insert page breaks - March 2020
  flexForPrint: PropTypes.bool
}

export default ContentContainer
